module.exports = __webpack_public_path__ + "static/media/KP_01.d4bc9ed4.jpg";